import { lazy } from "react";

//home
export const Home = lazy(() => import("./home/Home"));
export const Dependent = lazy(() => import("./home/dependents/dependent/Dependent"));
export const Benefits = lazy(() => import("./benefits/Benefits.jsx"));
export const Documents = lazy(() => import("./documents/Documents"));
export const Sidebar = lazy(() => import("./home/sidebar/Sidebar"));
export const BenefitsV2 = lazy(() => import("./benefits_v2/BenefitsV2.jsx"));
export const Banner = lazy(() => import("./home/banner/Banner"));
export const HealthMeter = lazy(() => import("./home/healthMeter/HealthMeter"));
export const AddFamilyMemberForm = lazy(() => import("./home/dependents/addFamilyMemberForm/AddFamilyMemberForm"));
export const PersonalHealthTest = lazy(() => import("./PersonalHealthTest/PersonalHealthTest"));
//Preview Home
export const PreviewHome = lazy(() => import("./previewHome/PreviewHome"));
export const PreviewSidebar = lazy(() => import("./previewHome/previewSidebar/PreviewSidebar"));
export const PreviewBanner = lazy(() => import("./previewHome/previewBanner/PreviewBanner"));
export const PreviewHealthMeter = lazy(() => import("./previewHome/previewHealthMeter/PreviewHealthMeter"));
export const PreviewClaim = lazy(() => import("./previewHome/previewClaim/PreviewClaim"));
//Claim
export const ClaimList = lazy(() => import("./claim/claimList/ClaimList"));
//EOB
export { default as EOB } from "./claim/EOB/EOB";
export const Branding = lazy(() => import("./claim/EOB/branding/Branding"));
export const EOBHeader = lazy(() => import("./claim/EOB/header/Header"));
export const EOBClaimLines = lazy(() => import("./claim/EOB/claimLines/ClaimLines"));
export const SubHeader = lazy(() => import("./claim/EOB/subHeader/SubHeader"));
export const PatientDetails = lazy(() => import("./claim/EOB/patientDetails/PatientDetails"));
export const SummaryDetails = lazy(() => import("./claim/EOB/summaryDetails/SummaryDetails"));
export const ProviderDetails = lazy(() => import("./claim/EOB/providerDetails/ProviderDetails"));
export const ClaimDetailsPdf = lazy(() => import("./claim/EOB/claimLines/ClaimDetailsPdf/ClaimDetailsPdf"));
export const EOBPrint = lazy(() => import("./claim/EOB/EOBPrint/EOBPrint"));
//profile
// export const Profile = lazy(() => import("./profile/Profile"));
// export const ProfileSidebar = lazy(() => import("./profile/sidebar/Sidebar"));
// export const ProfileHeader = lazy(() => import("./profile/header/Header"));
// export const ProfileDetails = lazy(() => import("./profile/profileDetails/ProfileDetails"));
// export const ContactDetails = lazy(() => import("./profile/contactDetails/ContactDetails"));
// export const ProfileSubHeader = lazy(() => import("./profile/profileSubHeader/ProfileSubHeader"));
// export const AddContacts = lazy(() => import("./profile/addContacts/AddContacts"));
export { default as Profile } from "./profile/Profile";
export { default as ProfileSidebar } from "./profile/sidebar/Sidebar";
export { default as ProfileHeader } from "./profile/header/Header";
export { default as ProfileDetails } from "./profile/profileDetails/ProfileDetails";
export { default as ContactDetails } from "./profile/contactDetails/ContactDetails";
export { default as ProfileSubHeader } from "./profile/profileSubHeader/ProfileSubHeader";
export { default as AddContacts } from "./profile/addContacts/AddContacts";
export { default as AddDependent } from "./dependents/addDependent/AddDependent.jsx";

//Dependents
export const Dependents = lazy(() => import("./dependents/Dependents"));
//Auth
export const ChangePassword = lazy(() => import("./auth/changePassword/ChangePassword"));
export const PasswordForm = lazy(() => import("./auth/changePassword/PasswordForm"));
export const ChangePasswordOTP = lazy(() => import("./auth/changePassword/OTP"));
export const Notifications = lazy(() => import("./../notifications/Notifications.jsx"));
export const Notification = lazy(() => import("./../notifications/Notification.jsx"));
export const AllNotifications = lazy(() => import("./../allNotifications/AllNotifications.jsx"));
export const AllNotification = lazy(() => import("./../allNotifications/AllNotification.jsx"));

//Enrollment
// export { default as LincolnForm } from "./enrollment/lincolnForm/LincolnForm.jsx";
// export { default as HeaderInformation } from "./enrollment/lincolnForm/headerInformation/HeaderInformation.jsx";
// export { default as PersonalInformation } from "./enrollment/lincolnForm/personalInformation/PersonalInformation.jsx";
// export { default as EmployerSection } from "./enrollment/lincolnForm/employerSection/EmployerSection.jsx";
// export { default as BenefitSelection } from "./enrollment/lincolnForm/benefitSelection/BenefitSelection.jsx";
// export { default as GSTD } from "./enrollment/GSTD/GSTD";
// export { default as ClinicCard } from "./enrollment/ClinicCard/ClinicCard";
// export { default as HealthBenefit } from "./enrollment/healthBenefit/HealthBenefit";
// export { default as HealthBenefitForm } from "./enrollment/healthBenefitForm/HealthBenefitForm.jsx";
// export { default as GLTD } from "./enrollment/GLTD/GLTD";
// export { default as GLIInfo } from "./enrollment/GLIInfo/GLIInfo";
// export { default as EnrollmentsInfo } from "./enrollment/enrollmentsInfo/EnrollmentsInfo";
// export { default as GLTDClasses } from "./enrollment/GLTDClasses/GLTDClasses";
// export { default as KSOPInfo } from "./enrollment/KSOPInfo/KSOPInfo";
// export { default as GLIForm } from "./enrollment/GLIForm/GLIForm";
// export { default as AccessDeatils } from "./enrollment/ClinicCard/AccessDetails";
// export { default as GLTDInfo } from "./enrollment/GLTDInfo/GLTDInfo";

// export { default as EOB } from "./claim/EOB/EOB";
// export { default as Branding } from "./claim/EOB/branding/Branding";
// export { default as EOBHeader } from "./claim/EOB/header/Header";
// export { default as EOBClaimDetails } from "./claim/EOB/claimDetails/ClaimDetails.jsx";
// export { default as SubHeader } from "./claim/EOB/subHeader/SubHeader";
// export { default as PatientDetails } from "./claim/EOB/patientDetails/PatientDetails";
// export { default as SummaryDetails } from "./claim/EOB/summaryDetails/SummaryDetails";
// export { default as ProviderDetails } from "./claim/EOB/providerDetails/ProviderDetails";
// export { default as ClaimDetailsPdf } from "./claim/EOB/claimDetails/ClaimDetailsPdf/ClaimDetailsPdf";

//GLIForm
// export { default as HeaderContainer } from "./enrollment/GLIForm/headerSection/HeaderSection.jsx";
// export { default as NextHeaderSection } from "./enrollment/GLIForm/nextHeaderSection/NextSection.jsx";
// export { default as BeneficiaryGrid } from "./enrollment/GLIForm/beneficiaryGrid/BeneficiaryGrid.jsx";
// export { default as TermsCondition } from "./enrollment/GLIForm/footerTerms/TermsCondition.jsx";
// Health Card
export { default as HealthCard } from "./healthCard/BBIHealthCard/HealthCard";
export { default as HealthCardActualV2 } from "./healthCard/BBIHealthCard/healthCardActual/HealthCardActualV2";
export { default as HealthCardPrintV2 } from "./healthCard/BBIHealthCard/healthCardPrint/HealthCardPrintV2";

//enrollment
export { default as Enrollment } from "./enrollment/Enrollment";

export { default as HealthPlanBranding } from "./enrollment/plans/healthPlan/branding/Branding";
export { default as HealthPlanForm } from "./enrollment/plans/healthPlan/form/HealthPlanForm";
export { default as VEBEnrollment } from "./VEBEnrollment/Enrollment";

export { default as KemperCancerForm } from "./VEBEnrollment/plans/kemper/cancer/form/CancerForm";
export { default as KemperCancerBranding } from "./VEBEnrollment/plans/kemper/cancer/branding/Branding";
// export { default as KemperAccidentBranding } from "./VEBEnrollment/plans/kemper/accident/branding/Branding";
// export { default as KemperCIBranding } from "./VEBEnrollment/plans/kemper/criticalIllness/branding/Branding";
// export { default as KemperHIBranding } from "./VEBEnrollment/plans/kemper/hospitalIndemnity/branding/Branding";
// export { default as KemperSTDBranding } from "./VEBEnrollment/plans/kemper/shortTermDisability/branding/Branding";
// export { default as KemperWholeLife } from "./VEBEnrollment/plans/kemper/shortTermDisability/branding/Branding";
// export { default as FiveStartBranding } from "./VEBEnrollment/plans/fiveStar/familyProtection/branding/Branding";
// export { default as DocRxBranding } from "./VEBEnrollment/plans/doc/docAndRx/branding/Branding";
// export { default as BeazleyBranding } from "./VEBEnrollment/plans/beazley/indemnity/branding/Branding";

export { default as ClinicCardBranding } from "./enrollment/plans/clinicCard/branding/Branding";
export { default as ClinicCardForm } from "./enrollment/plans/clinicCard/form/ClinicCardForm";

export { default as PDForm } from "./enrollment/plans/pd/PDForm";

export { default as KsopForm } from "./enrollment/plans/ksop/form/KsopForm";
export { default as KsopBranding } from "./enrollment/plans/ksop/branding/KsopBranding";
export { default as KsopHeaderInformation } from "./enrollment/plans/ksop/form/ksopHeaderInformation/KsopHeaderInformation.jsx";
export { default as KsopPersonalInformation } from "./enrollment/plans/ksop/form/ksopPersonalInformation/KsopPersonalInformation.jsx";
export { default as KsopBeneficiaryName } from "./enrollment/plans/ksop/form/ksopBeneficiaryName/KsopBeneficiaryName";
export { default as KsopNameChange } from "./enrollment/plans/ksop/form/ksopNameChange/KsopNameChange.jsx";
export { default as KsopPartcipantSignature } from "./enrollment/plans/ksop/form/ksopPartcipantSignature/KsopPartcipantSignature.jsx";
export { default as KsopBeneficiaryDesignation } from "./enrollment/plans/ksop/form/ksopBeneficiaryDesignation/KsopBeneficiaryDesignation";

export { default as GltdForm } from "./enrollment/plans/gltd/form/GltdForm";
export { default as GltdBranding } from "./enrollment/plans/gltd/branding/GltdBranding";

export { default as HOOBranding } from "./enrollment/plans/pd/branding/HOOBranding";

export { default as GliBranding } from "./enrollment/plans/gli/branding/GliBranding";

export { default as GstdForm } from "./enrollment/plans/gstd/form/GstdForm";
export { default as GstdBranding } from "./enrollment/plans/gstd/branding/GstdBranding";

export { default as CcedForm } from "./enrollment/plans/cce/form/CceForm";
export { default as CCeBranding } from "./enrollment/plans/cce/branding/Branding";
export { default as EnrollmentAcknowledgement } from "./enrollment/enrollmentAcknowledgement/EnrollmentAcknowledgement";
export const LazyHealthPlanAcknowledgement = lazy(
	() => import("./enrollment/plans/healthPlan/PlanAknowledgement/PlanAknowledgement")
);
export { default as PlanAknowledgement } from "./enrollment/plans/planAknowledgement/PlanAknowledgement";

export const LazyGroupBenefits = lazy(() => import("./benefits/groupBenefits/GroupBenefits"));
export const LazyBenefitsGrid = lazy(() => import("./benefits/benefitsGrid/BenefitsGrid"));
export const LazyVEBBenefits = lazy(() => import("./benefits/VEBBenefits/VEBBenefits"));
export const LazyVEBBenefitsGrid = lazy(() => import("./benefits/VEBBenefitsGrid/VEBBenefitsGrid"));
export const LazyDependentBenefits = lazy(
	() => import("./home/dependents/dependent/dependentBenefits/DependentBenefits")
);
export const LazyDependentBenefitsV2 = lazy(
	() => import("./home/dependents/dependent/dependenBenefitsCardV2/DependentBenefitCardV2")
);
export const LazyVEBDependentBenefits = lazy(
	() => import("./home/dependents/dependent/dependentBenefits/VEBDependentBenefits")
);
export const LazyVEBDependentBenefitsGrid = lazy(
	() => import("./home/dependents/dependent/dependentBenefits/VEBDependentBenefitsGrid/VEBDependentBenefitsGrid")
);

export const LazyEligibleDependentsGrid = lazy(
	() => import("./VEBEnrollment/eligiblityDialogs/eligibleDependentsGrid/EligibleDependentsGrid")
);
export const LazyIneligibleDependentsGrid = lazy(
	() => import("./VEBEnrollment/eligiblityDialogs/ineligibleDependentsGrid/IneligibleDependentsGrid")
);
export const LazyIneligibleRelationshipDependentsGrid = lazy(
	() =>
		import(
			"./VEBEnrollment/eligiblityDialogs/ineligibleRelationshipDependentsGrid/IneligibleRelationshipDependentsGrid"
		)
);

export { default as PersonalHealthTracker } from "./home/PersonalHealthTracker/PersonalHealthTracker";
export { default as PersonalHealthTrackerInitial } from "./home/PersonalHealthTrackerInitial/PersonalHealthTrackerInitial";
// ======================================= [ INTERCITY IVESTMENTS INC ] ===============================================

export { default as IntercityPlanAcknowledgement } from "./enrollment/IntercityInvestments/intercityPlans/intercityPlanAcknowledgement/IntercityPlanAcknowledgement";

// --------------------------------------- ( BRANDING COMPONENTS ) ---------------------------------------------------
export { default as IntercityEnrollment } from "./enrollment/IntercityInvestments/IntercityEnrollment";
export { default as IntercityHealthPlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/healthPlan/branding/IntercityHealthPlanBranding";
export { default as IntercityGLTDPlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/groupLongTermDisability/branding/IntercityGLTDBranding";
export { default as IntercityFlexMedPlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/FlexMed/branding/IntercityFlexMedBranding";
export { default as IntercityFlexCarePlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/FlexCare/branding/IntercityFlexCareBranding";
export { default as IntercityGLIFreePlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/groupLifeInsuranceFree/branding/IntercityGLIFreeBranding";
export { default as IntercityGLIOptionalPlanBranding } from "./enrollment/IntercityInvestments/intercityPlans/groupLifeInsuranceOptional/branding/IntercityGLIOptionalBranding";

// --------------------------------------- ( FORM COMPONENTS ) ---------------------------------------------------

export { default as IntercityHealthPlanForm } from "./enrollment/IntercityInvestments/intercityPlans/healthPlan/form/IntercityHealthPlanForm";
export { default as IntercityGLTDForm } from "./enrollment/IntercityInvestments/intercityPlans/groupLongTermDisability/form/IntercityGLTDForm";

// =========================================== [ PANHANDLE FIRST BANK ] ==============================
export { default as BOPHealthCard } from "./healthCard/BOPHealthCard/BOPHealthCard";

// -----------------------------------{           enrollments        v2} -------------------------------------

// enrollment
